export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const TOKEN_INVALIDATES_IN = 'tokenInvalidatesIn';
